<template>

    <v-container class="pa-0 ma-0" fluid>
        <cards-body :title="title" :icon="icon" :no-btn-create="noBtnCreate" @clickedCreateButton="emit('clickedCreateButton')" :hide-title="hideTitle">
            <!-- Adiciona botões na parte do título do card -->
            <template v-slot:tools>
                <v-spacer></v-spacer>
                <slot name="tools"></slot>
            </template>

            <slot></slot>
        </cards-body>
    </v-container>

</template>

<script setup>

import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    title: { type: String, required: false },
    icon: { type: String, required: false },
    noBtnCreate: { type: Boolean, default: false },
    hideTitle: { type: Boolean, default: false }
})

const emit = defineEmits(['clickedCreateButton'])

</script>